import { UntypedFormControl } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { IListByFilterMedico, IMedico } from '../models/doctor';
import { DoctorService } from '../services/doctor.service';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { EAccountRole, ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { IPerfilAcesso } from '../../roles/models/role';

@Component({
  selector: 'app-doctor',
  templateUrl: './doctor.component.html',
  styleUrls: ['./doctor.component.scss']
})
export class DoctorComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  acaoInput = new UntypedFormControl();
  ordenarControl = new UntypedFormControl(1);
  doctors: IMedico[] = [];
  opcoesPerfilAcesso: IPerfilAcesso[] = [];
  opcoesOrdenacao = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais novos'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Mais antigos'
    }
  ];
  dadosPaginacao = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  companyId?: string;
  partnerId?: string;
  accountRole?: string;

  constructor(
    private readonly doctorservice: DoctorService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.companyId = this.sessionService.getSession().companyId;
    this.partnerId = this.sessionService.getSession().partnerId;
    this.accountRole = this.sessionService.getSession().accountRole;
    this.getListPerfilAcesso();
    this.carregarMedicos();
    this.ordenarControl.valueChanges.subscribe((ordenacaoSelecionada: EOrdenacao) => {
      this.dadosPaginacao.ordenacao = ordenacaoSelecionada;
      this.carregarMedicos();
    });
  }

  filtrarMedico(): void {
    // Busca nova começa da primeira página; na página 3 um termo com 1 resultado mostraria a lista vazia.
    this.dadosPaginacao.paginaSelecionada = 0;
    this.carregarMedicos();
  }

  limparFiltros(): void {
    this.acaoInput.reset();
    this.filtrarMedico();
  }

  carregarMedicos(): void {
    const filtros = this.buildMedicoFilterOptions();

    this.doctorservice.listarTodosMedicos(filtros).subscribe((res) => {
      this.doctors = res.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(res.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = res.count!;
    });
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;

    this.carregarMedicos();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.dadosPaginacao.paginaSelecionada = 0;

    this.carregarMedicos();
  }

  public downloadExcel(): void {
    const filtros = this.buildMedicoFilterOptions();

    this.doctorservice.exportarExcel(filtros);
  }

  buildMedicoFilterOptions(): IListByFilterMedico {
    const filtros: IListByFilterMedico = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    };

    const searchText = String(this.acaoInput.value ?? '').trim();
    if (searchText) {
      filtros.searchText = searchText;
    }

    if (this.companyId) {
      filtros.companyId = this.companyId;
    }

    if (this.partnerId) {
      filtros.partnerId = this.partnerId;
    }

    if (this.accountRole) {
      filtros.accountRole = parseInt(this.accountRole);
    }

    return filtros;
  }

  getListPerfilAcesso(): void {
    this.doctorservice.listarPerfisComPermissao().subscribe((resposta) => {
      this.opcoesPerfilAcesso = resposta.data;
    });
  }
}
